import { NAMESPACE } from './constants';

export const PARSE_APPIUM_JOB = `${NAMESPACE}/PARSE_APPIUM_JOB`;
export const PARSE_SELENIUM_JOB = `${NAMESPACE}/PARSE_SELENIUM_JOB`;
